var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(-1363 -5067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1401.114,5079.183h-3.457v-3.532a1.134,1.134,0,0,0-.331-.8l-6.764-6.764a1.133,1.133,0,0,0-.8-.33h-20.294a1.127,1.127,0,0,0-1.128,1.127v10.3h-3.457a1.127,1.127,0,0,0-1.127,1.128v18.038a1.127,1.127,0,0,0,1.127,1.128h3.457v5.637a1.127,1.127,0,0,0,1.128,1.127h27.058a1.127,1.127,0,0,0,1.128-1.127v-5.637h3.457a1.127,1.127,0,0,0,1.127-1.128v-18.038A1.127,1.127,0,0,0,1401.114,5079.183Zm-10.222-7.575,2.915,2.915h-2.915Zm-20.294-1.595h18.039v5.638a1.128,1.128,0,0,0,1.128,1.127h5.637v2.405h-24.8Zm24.8,33.974h-24.8v-4.51h24.8Zm4.585-6.765h-33.974v-15.784h33.974Zm-26.006-2.255a3.385,3.385,0,0,0,3.382-3.382v-4.51a3.383,3.383,0,0,0-6.765,0v4.51A3.386,3.386,0,0,0,1373.981,5094.967Zm-1.128-7.892a1.128,1.128,0,0,1,2.255,0v4.51a1.128,1.128,0,0,1-2.255,0Zm7.892,7.892H1383a6.071,6.071,0,0,0,0-11.274h-2.255a1.128,1.128,0,0,0-1.127,1.127v9.02A1.127,1.127,0,0,0,1380.745,5094.967Zm1.128-9.019H1383a1.127,1.127,0,0,1,0,2.255h-1.127Zm0,4.509H1383a1.127,1.127,0,0,1,0,2.255h-1.127Zm6.764,1.128a1.128,1.128,0,1,1,2.255,0,1.128,1.128,0,0,0,2.255,0v-5.637h-1.128a1.128,1.128,0,0,1,0-2.255h2.255a1.128,1.128,0,0,1,1.128,1.127v6.765a3.383,3.383,0,0,1-6.765,0Z",
    fill: "#3d4463"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 40,
    height: 40,
    transform: "translate(1363 5067)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObject);
export default __webpack_public_path__ + "static/media/icon-object.e71998826b35ddb14f5a264765b3e822.svg";
export { ForwardRef as ReactComponent };